export const STORE_ROUTER_HISTORY: 'ROUTER/STORE_ROUTER_HISTORY' = 'ROUTER/STORE_ROUTER_HISTORY';
